/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Main preview documents component
 */

// Dependencies
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Components
import ImgViewer from './imgViewer';
import PDFViewer from './pdfViewer';
import VideoViewer from './videoViewer';

const PreviewDocuments = ({ url, fileType }) => {
  const { t: translate } = useTranslation();
  const getPreviewer = () => {
    switch (fileType) {
      case 1:
        return <PDFViewer url={url} />;
      case 2:
        return <ImgViewer url={url} />;
      case 3:
        return <VideoViewer url={url} />;
      default:
        return translate('previewDocuments.extensionErrorMessage');
    }
  };
  return (
    <div
      onContextMenu={(e) => {
        e.preventDefault();
        return false;
      }}>
      {getPreviewer()}
    </div>
  );
};

/**
 * Component definition of proptypes
 */
PreviewDocuments.propTypes = {
  url: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  fileType: PropTypes.number.isRequired
};

export default PreviewDocuments;
